export const isNull = (val) => val === undefined || val === null || val === '';